<component v-if="shouldRenderConfig" v-bind:is="getContainerType" v-bind:class="getClassName">
    <div
        v-for="(pageOption,key,index) in getActiveProductPageOptions"
        v-bind:key="index"
        v-bind:code="key"
        v-bind:index="index"
        v-bind:class="getClassNameItem"
        v-show="IsActive(key)"
    >
        <appPageOptionAttributesContainer v-bind:code="key"></appPageOptionAttributesContainer>
    </div>
</component>